import React from 'react';
import { useAuthContext } from 'hooks/useAuthContext'; 

const useCanDoAction = (scope, action) => {
  const { role } = useAuthContext();
  const canDo = React.useMemo(() => role && role.check(scope, action), [scope, action, role]);
  return canDo;
}

export { useCanDoAction };